const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'prime_merchandising_bubble',
    modelClass: Backbone.Model,
    viewClass: require('./view'),
});
